import React from 'react';
import { Checkbox, Grid, Header, Icon, Label, Popup, Table } from 'semantic-ui-react';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from "../../util/PaginationFront";


// eslint-disable-next-line import/prefer-default-export
export const CollisionList = ({
    data, getResults, checkAllFlag, checkAll, dataToShow, checkedCourses, handleCheckboxChange
}) => (<div>{ data.length ? <Table celled selectable compact>
    <Table.Header>
        <Table.Row>
            <Table.HeaderCell colSpan={16} >
                <div style={{ paddingLeft: '30px' }}>
                    <SearchTableData data={data} getResults={getResults} filterItem={['id', 'courseBasicName']} />
                </div>
            </Table.HeaderCell>
        </Table.Row>
        <Table.Row>
            <Table.HeaderCell width={1} verticalAlign="middle" textAlign="center" >
                <Header as="h5">
                    <Checkbox
                        checked={checkAllFlag}
                        onChange={(e, { checked }) => { checkAll(checked); }}
                    />
                    <Header.Subheader>Označi sve</Header.Subheader>
                </Header>


            </Table.HeaderCell>
            <Table.HeaderCell width="1">R. br.</Table.HeaderCell>
            <Table.HeaderCell colSpan="10">
                <Header as="h4"> Predmet</Header>
            </Table.HeaderCell>
            <Table.HeaderCell colSpan="4">
                <Header as="h4">
                    <Header.Content>
                        Napomena
                        <Header.Subheader>Predmet / implementacija</Header.Subheader>
                    </Header.Content>
                </Header>
            </Table.HeaderCell>
        </Table.Row>
    </Table.Header>
    <Table.Body> {dataToShow.map((row, index) =>
        (<Table.Row key={row.id}>
            <Table.Cell verticalAlign="middle" textAlign="center">
                <Checkbox
                    checked={checkedCourses.filter(el => el === row.id).length !== 0}
                    onChange={(e, { checked }) => { handleCheckboxChange(row.id, checked); }}
                />
            </Table.Cell>
            <Table.Cell verticalAlign="middle">
                {index + 1}.
            </Table.Cell>
            <Popup
                content={row.semesters[0].name._key === 'winter semester' ? 'Implementacija predmeta u zimskom semestru' : 'Implementacija predmeta u ljetnom semestru'}
                hideOnScroll
                position="left center"
                trigger={<Table.Cell verticalAlign="middle" colSpan="10">
                    <Grid columns={1} centered className="stackable">
                        <Grid.Row verticalAlign="middle">
                            <Grid.Column width="10">
                                <span >  { row.semesters[0].name._key === 'winter semester' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />}{row.code ? row.courseBasic.name + ' | ' + row.code : row.courseBasic.name}</span>
                            </Grid.Column>
                            <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                {/* <span style={{ color: '#a6a4a1' }}>{row.courseComment}</span> */}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Table.Cell>}
            />
            <Table.Cell verticalAlign="middle" colSpan="4">
                <span>
                    {row.courseBasic.comment && <Popup content="Predmet" hideOnScroll position="top center" trigger={<Label as="a" basic><Icon name="comment alternate outline" /> {row.courseBasic.comment}</Label>} />}
                    {row.comment && <Popup content="Implementacija" hideOnScroll position="top center" trigger={<Label as="a" basic><Icon name="comment alternate outline" /> {row.comment}</Label>} />}

                </span>

            </Table.Cell>
        </Table.Row>))}
    </Table.Body>
</Table> : <div><br />Nema predmeta u ovom semestru.<br /></div>}

</div>);
// class CollisionList extends Component {
//     render() {
//         return (
//
//         );
//     }
// }
//
// export default CollisionList;



// WEBPACK FOOTER //
// ./src/views/StudentService/Collision/CollisionList.js